import React from 'react';
import InfoIcon from '@mui/icons-material/Info';


export const getInfoIcon = () => (
    <InfoIcon color={'info'} />
)